var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidslittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.31 15.31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #5b5757;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.65 4c0-2.21-1.79-4-4-4s-4 1.79-4 4h0.35v-0.35c-2.21 0-4 1.79-4 4s1.79 4 4 4v-0.35h-0.35c0 2.21 1.79 4 4 4s4-1.79 4-4h-0.35v0.35c2.21 0 4-1.79 4-4s-1.79-4-4-4v0.69c1.83 0 3.31 1.48 3.31 3.31s-1.48 3.31-3.31 3.31h-0.35v0.35c0 1.83-1.48 3.3-3.31 3.31-1.83 0-3.31-1.48-3.31-3.31v-0.35h-0.35c-1.83 0-3.31-1.48-3.31-3.31s1.48-3.31 3.31-3.31h0.35v-0.35c0-1.83 1.48-3.31 3.31-3.31s3.31 1.48 3.31 3.31h0.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.89,7.63h-.25c0,1.11-.45,2.11-1.17,2.83-.72.72-1.72,1.17-2.83,1.17s-2.1-.45-2.83-1.17c-.72-.72-1.17-1.72-1.17-2.83s.45-2.11,1.17-2.83c.73-.72,1.72-1.17,2.83-1.17s2.11.45,2.83,1.17c.73.73,1.17,1.72,1.17,2.83h.5c0-2.49-2.02-4.5-4.5-4.5S3.14,5.14,3.14,7.63s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5h-.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidslittle);
export default __webpack_public_path__ + "static/media/kidslittle.25e2c12be22120690b6b45253f39aa6a.svg";
export { ForwardRef as ReactComponent };